import { AxiosGetRequestOptions, AxiosPostRequestOptions } from '@/package';
import type { StatisticApi } from '@/type/statiscType';
import { apiOf } from '@/util';

export const getState = apiOf<
  StatisticApi.GetState.Request,
  StatisticApi.GetState.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/statistic/state/:pTarget' }));

export const getObject = apiOf<
  StatisticApi.GetObject.Request,
  StatisticApi.GetObject.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/statistic/object' }));

export const syncStatistic = apiOf<
  StatisticApi.SyncStatistic.Request,
  StatisticApi.SyncStatistic.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/statistic/synchronize' }));

export const getUserMetric = apiOf<
  StatisticApi.GetMetric.Request,
  StatisticApi.GetMetric.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/user/metric',
    defaultQuery: {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  }),
);
